<template>
  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="8"
          md="4"
      >
        <RegisterComponent @back="onBack" @registered="onRegistered"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RegisterComponent from '../../components/RegisterComponent'
import {AUTH_REQUEST} from "@/store/modules/auth/actions";
import {AUTH_SUCCESS} from "@/events/auth";
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "RegisterPage",
  components: {
    RegisterComponent
  },
  methods: {
    onAuthSuccess() {
      this.$router.push({name: 'dashboard'})
    },

    onBack() {
      this.$router.go(-1)
    },
    onRegistered({username, password}) {
      this.$store.dispatch(AUTH_REQUEST, {username: username, password: password})
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('registerPage.title'))
    this.$bus.$on(AUTH_SUCCESS, this.onAuthSuccess)
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_SUCCESS, this.onAuthSuccess)
  }
}
</script>

<style scoped>

</style>